export default "__VITE_ASSET__Dog1ncUH__"